import corporateTrainingImage from "../pics/XT307632.jpg";
import { courseNames } from "./courseNames";

const siteUrl = "https://barcelonacodeschool.com";
const imageBase = `${siteUrl}/files/pics`;
const aiCategory = {
  breadcrumbCategory: "AI courses",
  categoryUrl: `${siteUrl}/ai-agents/`,
};
export const courseSeoByPath = {
  "/vibe-coding-bootcamp-with-claude/": {
    ...aiCategory,
    name: courseNames["/vibe-coding-bootcamp-with-claude/"],
    alternateName: "Vibe Coding Bootcamp with Claude Code",
    description:
      "Learn vibe coding with Claude Code and build your own iPhone and Android app in one full-time week. Live in Barcelona or online; no coding required.",
    socialDescription:
      "A full-time Claude Code course in Barcelona or online live. Learn how mobile apps are built and build your own in one week.",
    keywords: [
      "vibe coding bootcamp",
      "Claude Code course",
      "AI coding course",
      "mobile app course",
      "React Native course",
      "Expo course",
      "vibe coding Barcelona",
      "build an app with AI",
    ],
    image: `${imageBase}/web_development_bootcamp_barcelona_code_school_optimized.jpg`,
    imageAlt:
      "Vibe Coding Bootcamp with Claude Code at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "PT40H",
    courseWorkload: "40 live hours, Monday to Friday from 09:00 to 18:00 CET",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites:
      "No coding experience is required. Students should be confident computer users who already use ChatGPT or Claude.",
    credential: "Barcelona Code School Vibe Coding Bootcamp certificate",
    audience:
      "Founders, product managers, marketers, analysts and business owners who want to build a mobile app with AI",
    teaches: [
      "Vibe coding",
      "Claude Code",
      "React Native",
      "Expo",
      "Supabase",
      "Git and GitHub",
      "Mobile app testing",
      "App Store and Google Play publishing workflows",
    ],
    price: 1600,
    instances: [
      {
        name: "Vibe Coding Bootcamp - November 2026",
        startDate: "2026-11-30",
        endDate: "2026-12-04",
      },
    ],
    faqs: [
      {
        question: "Do I need to know how to code to learn vibe coding?",
        answer:
          "No. Students describe what they need in plain English, Claude Code writes the code, and the instructor explains how to check the result.",
      },
      {
        question: "Can I take the Vibe Coding Bootcamp online?",
        answer:
          "Yes. Online students join the same live class as students in Barcelona and receive the same instructor support.",
      },
      {
        question: "Do I need Apple and Google developer accounts?",
        answer:
          "No. Developer accounts are only required if a student later decides to submit an app to the stores.",
      },
    ],
  },
  "/ai-business-automation-architect/": {
    ...aiCategory,
    name: courseNames["/ai-business-automation-architect/"],
    alternateName: "No-Code AI Agent & Automation Bootcamp",
    description:
      "Build a no-code Virtual AI Department with n8n, RAG, Airtable, Supabase, connected agents and human approvals. Four weeks, live in Barcelona or online.",
    keywords: [
      "ai automation course",
      "AI Agent & Automation Bootcamp",
      "n8n course",
      "no-code AI agents",
      "RAG course",
      "AI automation Barcelona",
      "Virtual AI Department",
    ],
    image: `${imageBase}/ai_business_automation_architect_barcelona_code_school.jpg`,
    imageAlt:
      "AI Agent & Automation Bootcamp at Barcelona Code School",
    courseMode: ["On campus", "Remote live"],
    duration: "P4W",
    courseWorkload: "40 hours per week for 4 weeks; 160 hours total",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites: "No coding experience is required.",
    audience:
      "Career changers, operations professionals, founders and automation consultants",
    teaches: [
      "n8n workflow automation",
      "AI agents",
      "RAG knowledge bases",
      "Airtable and Supabase",
      "Human-in-the-loop approvals",
      "Business process automation",
    ],
    price: 3600,
    structuredData: false,
  },
  "/work-automation-with-ai-agents/": {
    ...aiCategory,
    name: courseNames["/work-automation-with-ai-agents/"],
    alternateName: "AI Power Stack Course",
    description:
      "Build a personal AI stack and deploy an agent that handles real work with Claude, MCP and n8n. Eight live hours in Barcelona or online; no coding required.",
    keywords: [
      "AI agents course",
      "work automation course",
      "Claude course",
      "MCP course",
      "n8n AI agent",
      "AI automation Barcelona",
      "personal AI stack",
    ],
    image: `${imageBase}/ai_agents_banner.jpg`,
    imageAlt: "Work Automation with AI Agents course at Barcelona Code School",
    courseMode: ["On campus", "Remote live"],
    duration: "PT8H",
    courseWorkload:
      "8 hours total, delivered as one workshop day or three evening sessions",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites: "No coding experience is required.",
    credential: "Barcelona Code School course certificate",
    audience:
      "Entrepreneurs, marketers, product managers, creators and office professionals",
    teaches: [
      "Personal AI systems",
      "AI agent design",
      "Claude Code",
      "Model Context Protocol (MCP)",
      "n8n automation",
      "Business tool integrations",
    ],
    price: 490,
    instances: [
      {
        name: "AI Agents Course — evening sessions — August 2026",
        startDate: "2026-08-25",
        endDate: "2026-08-27",
      },
      {
        name: "AI Agents Course — one-day workshop — August 2026",
        startDate: "2026-08-29",
      },
      {
        name: "AI Agents Course — evening sessions — September 2026",
        startDate: "2026-09-15",
        endDate: "2026-09-17",
      },
      {
        name: "AI Agents Course — one-day workshop — September 2026",
        startDate: "2026-09-26",
      },
      {
        name: "AI Agents Course — evening sessions — October 2026",
        startDate: "2026-10-20",
        endDate: "2026-10-22",
      },
      {
        name: "AI Agents Course — one-day workshop — October 2026",
        startDate: "2026-10-24",
      },
    ],
  },
  "/machine-learning-and-ai-engineering-bootcamp/": {
    ...aiCategory,
    name: courseNames["/machine-learning-and-ai-engineering-bootcamp/"],
    alternateName: "Deep Learning and AI Engineering Bootcamp",
    description:
      "Become an ML/AI engineer in 13 weeks. Build RAG systems, fine-tune LLMs and learn LLMOps with one-to-one mentoring from an AI researcher. Online, part-time.",
    keywords: [
      "machine learning bootcamp",
      "AI engineering bootcamp",
      "deep learning course",
      "RAG course",
      "LLM fine-tuning",
      "Hugging Face course",
      "LLMOps course",
    ],
    image: `${imageBase}/deep_learning_bootcamp.jpg`,
    imageAlt:
      "Deep Learning and AI Engineering Bootcamp at Barcelona Code School",
    imageHeight: 904,
    courseMode: ["Online", "Part-time", "One-to-one mentored"],
    duration: "P13W",
    language: "en",
    educationalLevel: "Beginner to intermediate",
    prerequisites:
      "Python preparation materials are included before the bootcamp.",
    credential: "Barcelona Code School AI Engineering Bootcamp certificate",
    audience:
      "Aspiring machine learning engineers, AI engineers and data scientists",
    teaches: [
      "Python for machine learning",
      "Deep learning",
      "Neural networks",
      "Hugging Face Transformers",
      "RAG pipelines",
      "LLM fine-tuning",
      "LangChain",
      "LLMOps and cloud deployment",
    ],
    price: 3950,
    instances: [
      { startDate: "2026-08-03", endDate: "2026-10-30" },
      { startDate: "2026-09-07", endDate: "2026-11-04" },
      { startDate: "2026-10-05", endDate: "2027-01-01" },
      { startDate: "2026-11-02", endDate: "2027-01-29" },
      { startDate: "2026-12-07", endDate: "2027-03-05" },
    ],
  },
  "/barcelona-code-school/javascript-full-stack-bootcamp/": {
    name: courseNames["/barcelona-code-school/javascript-full-stack-bootcamp/"],
    alternateName: "Web / Mobile Development Full-Time Bootcamp",
    description:
      "AI-native 9-week full-time bootcamp, on campus in Barcelona or remote live. Learn the full software engineering stack - JavaScript, TypeScript, React, React Native, Node, Express and MongoDB - plus a dedicated AI engineering track: AI-assisted development with Claude Code, prompt and context engineering, MCP integrations, LLM APIs, RAG, vector databases, agentic patterns and evaluation. 360 hours, groups of max 6.",
    keywords: [
      "web development bootcamp with AI",
      "AI web development bootcamp Barcelona",
      "AI engineering bootcamp",
      "javascript bootcamp with AI",
      "full-stack bootcamp Barcelona",
      "claude code for developers",
      "AI coding assistant course",
      "RAG course",
      "LLM API course",
      "vector database course",
      "React course",
      "React Native course",
      "Node.js bootcamp",
    ],
    image: `${imageBase}/web_development_bootcamp_barcelona_code_school.jpg`,
    imageAlt:
      "Full-Stack Web and Mobile Development Bootcamp with AI at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P9W",
    courseWorkload: "40 hours per week for 9 weeks; 360 hours total",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites:
      "No prior experience is required; pre-course preparation materials are provided.",
    credential:
      "Barcelona Code School Web / Mobile Development Bootcamp certificate",
    audience:
      "Career changers preparing for junior full-stack developer roles that expect AI-assisted workflows",
    teaches: [
      "JavaScript",
      "TypeScript",
      "React",
      "React Native",
      "Node.js",
      "Express",
      "MongoDB",
      "HTML and CSS",
      "Git and GitHub",
      "Authentication, security and deployment",
      "AI-assisted development with Claude Code",
      "Prompt and context engineering for developers",
      "MCP integrations",
      "Reviewing and hardening AI-generated code",
      "LLM APIs, streaming and tool calling",
      "RAG, embeddings and vector databases",
      "Agentic patterns and human-in-the-loop design",
      "Evaluation, guardrails and AI cost control",
    ],
    price: 5800,
    structuredData: false,
  },
  "/barcelona-code-school/javascript-full-stack-online-bootcamp/": {
    name:
      courseNames["/barcelona-code-school/javascript-full-stack-online-bootcamp/"],
    alternateName: "Web / Mobile Development Part-Time Online Bootcamp",
    description:
      "AI-native, part-time, one-to-one mentored online bootcamp. Choose a 13 or 16 week track and learn the full software engineering stack - JavaScript, TypeScript, React, React Native, Node.js, Express and MongoDB - plus a dedicated AI engineering track: AI-assisted development with Claude Code, prompt and context engineering, MCP integrations, LLM APIs, RAG, vector databases, agentic patterns and evaluation.",
    keywords: [
      "web development bootcamp with AI",
      "part-time web development bootcamp",
      "online AI development bootcamp",
      "javascript bootcamp with AI",
      "AI engineering bootcamp",
      "mentored coding bootcamp",
      "claude code for developers",
      "AI coding assistant course",
      "RAG course",
      "LLM API course",
      "vector database course",
      "React bootcamp online",
      "React Native course",
    ],
    image: `${imageBase}/web_development_online_bootcamp_barcelona_code_school.jpg`,
    imageAlt:
      "Online Full-Stack Web and Mobile Development Bootcamp with AI",
    courseMode: ["Online", "Self-paced", "Mentored"],
    duration: ["P13W", "P16W"],
    language: "en",
    educationalLevel: "Beginner",
    prerequisites:
      "No prior experience is required; pre-course preparation materials are provided.",
    credential:
      "Barcelona Code School Web / Mobile Development Bootcamp certificate",
    audience:
      "Career changers who need flexible, AI-ready online full-stack training",
    teaches: [
      "JavaScript",
      "TypeScript",
      "React",
      "React Native",
      "Node.js",
      "Express",
      "MongoDB",
      "HTML and CSS",
      "Git and GitHub",
      "Authentication, security and deployment",
      "AI-assisted development with Claude Code",
      "Prompt and context engineering for developers",
      "MCP integrations",
      "Reviewing and hardening AI-generated code",
      "LLM APIs, streaming and tool calling",
      "RAG, embeddings and vector databases",
      "Agentic patterns and human-in-the-loop design",
      "Evaluation, guardrails and AI cost control",
    ],
    lowPrice: 2500,
    highPrice: 2900,
    structuredData: false,
  },
  "/game-development-bootcamp/": {
    name: courseNames["/game-development-bootcamp/"],
    description:
      "Become a game developer in nine intensive weeks. Learn Unity, C#, game design, storytelling and publishing while building 2D and 3D games for your portfolio.",
    keywords: [
      "game development bootcamp",
      "Unity bootcamp",
      "C# course",
      "game design course Barcelona",
      "game programming bootcamp",
      "learn Unity",
    ],
    image: `${imageBase}/game_development_bootcamp.jpg`,
    imageAlt:
      "Game Development Bootcamp with Unity and C# at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P9W",
    language: "en",
    educationalLevel: "Beginner",
    credential: "Barcelona Code School Game Development Bootcamp certificate",
    audience:
      "Aspiring game developers preparing for junior roles or independent game production",
    teaches: [
      "C# programming",
      "Unity engine",
      "2D and 3D game development",
      "Game design",
      "Storytelling",
      "Game UI/UX",
      "Publishing games",
    ],
    price: 6200,
    instances: [
      { startDate: "2026-09-14", endDate: "2026-11-13" },
      { startDate: "2027-01-11", endDate: "2027-03-12" },
    ],
  },
  "/game-development-online-bootcamp/": {
    name: courseNames["/game-development-online-bootcamp/"],
    description:
      "Learn Unity and C# online in 13 weeks with live instructor support. Build 2D and 3D games, understand the production cycle and create portfolio projects.",
    keywords: [
      "online game development bootcamp",
      "Unity course online",
      "C# bootcamp online",
      "game design course",
      "learn game development",
      "Unity mentoring",
    ],
    image: `${imageBase}/game_development_online_bootcamp_banner.png`,
    imageAlt: "Online Game Development Bootcamp with Unity and C#",
    courseMode: ["Online", "Part-time", "Mentored"],
    duration: "P13W",
    courseWorkload: "Approximately 30 hours per week for 13 weeks",
    language: "en",
    educationalLevel: "Beginner",
    credential: "Barcelona Code School Game Development Bootcamp certificate",
    audience: "Aspiring game developers who need flexible online training",
    teaches: [
      "C# programming",
      "Unity engine",
      "2D and 3D game development",
      "Game design",
      "Game production",
      "Portfolio development",
    ],
    price: 4200,
    instances: [
      { startDate: "2026-08-17" },
      { startDate: "2026-09-14" },
      { startDate: "2026-10-12" },
      { startDate: "2026-11-09" },
      { startDate: "2027-01-11" },
      { startDate: "2027-02-08" },
    ],
  },
  "/ux-design-bootcamp-in-barcelona-code-school/": {
    name: courseNames["/ux-design-bootcamp-in-barcelona-code-school/"],
    alternateName: "UX/UI Design Full-Time Bootcamp with AI",
    description:
      "AI-native, nine-week full-time UX/UI Design Bootcamp on campus in Barcelona or remote live. Four real sprints, seven theory modules and a dedicated AI module covering prompt and context engineering, Claude, Claude Code, Claude Design, Figma AI, Framer AI and MCP. Finish with four case studies and a live portfolio website you shipped yourself.",
    keywords: [
      "UX design bootcamp with AI",
      "AI UX design course",
      "UX design bootcamp Barcelona",
      "UI design bootcamp",
      "AI UX designer training",
      "Claude for designers",
      "Claude Code for designers",
      "Figma AI course",
      "Framer AI course",
      "prompt engineering for designers",
      "product design course",
      "UX research course",
      "UX portfolio course",
    ],
    image: `${imageBase}/Banner_ux_design_bootcamp.jpg`,
    imageAlt: "UX/UI Design Bootcamp with AI at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P9W",
    courseWorkload:
      "35 hours per week for 9 weeks; Monday to Friday, 10:00 to 17:00 CET",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites: "No previous design experience is required.",
    credential: "Barcelona Code School UX/UI Design Bootcamp certificate",
    audience:
      "Career changers preparing for AI-assisted UX/UI, product design and digital strategy roles",
    teaches: [
      "UX research",
      "Design thinking",
      "Service design",
      "Lean Startup and business analysis for designers",
      "Information architecture",
      "Wireframing",
      "Prototyping",
      "Usability testing",
      "UI design and design systems",
      "AI-assisted design workflows",
      "Prompt and context engineering for designers",
      "Prompt-to-prototype with Claude Design and Figma AI",
      "Claude Code, MCP integrations and AI quality rubrics",
      "AI ethics, bias, guardrails and accessibility",
      "Case study writing and portfolio development",
    ],
    price: 5800,
    instances: [
      { startDate: "2026-09-07", endDate: "2026-11-06" },
      { startDate: "2026-10-19", endDate: "2026-12-18" },
      { startDate: "2026-11-09", endDate: "2027-01-15" },
      { startDate: "2027-01-04", endDate: "2027-03-05" },
      { startDate: "2027-03-15", endDate: "2027-05-14" },
      { startDate: "2027-05-17", endDate: "2027-07-16" },
    ],
  },
  "/ux-design-online-mentored-bootcamp/": {
    name: courseNames["/ux-design-online-mentored-bootcamp/"],
    alternateName: "Online Mentored UX/UI Design Bootcamp with AI",
    description:
      "Part-time, one-to-one mentored UX/UI Design Bootcamp with AI. Nine weeks, one real project taken from problem definition to a validated prototype, with an AI workflow built in at every phase: Claude, Claude Design and Figma AI. Finish with a portfolio-ready case study.",
    keywords: [
      "UX design bootcamp with AI",
      "part-time UX bootcamp",
      "online UX design bootcamp",
      "mentored UX bootcamp",
      "AI UX design course",
      "UX course with mentor",
      "Claude for designers",
      "Claude Design course",
      "Figma AI course",
      "prompt engineering for designers",
      "UX case study course",
      "UX portfolio course",
    ],
    image: `${imageBase}/ux_online_course.jpg`,
    imageAlt:
      "Part-time UX/UI Design Bootcamp with AI and one-to-one mentoring",
    courseMode: ["Online", "Part-time", "One-to-one mentored"],
    duration: "P9W",
    courseWorkload: "2 to 5 hours per week for 9 weeks",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites: "No previous design experience is required.",
    credential: "Barcelona Code School UX/UI Design Bootcamp certificate",
    audience:
      "Beginners and career changers who need flexible, AI-ready UX/UI training",
    teaches: [
      "UX research",
      "Problem definition",
      "Benchmarking and desk research",
      "Information architecture",
      "Wireframing",
      "Prototyping",
      "Design systems and branding",
      "Usability testing",
      "AI-assisted design workflows",
      "Prompt and context engineering for designers",
      "Prompt-to-prototype with Claude Design and Figma AI",
      "AI ethics, verification and accessibility",
      "UX case-study development",
    ],
    price: 2900,
  },
  "/ai-compliance-training/": {
    ...aiCategory,
    name: courseNames["/ai-compliance-training/"],
    description:
      "Prepare your team for EU AI Act Article 4 with live, role-based AI literacy training and documented evidence. Train in Barcelona, remotely or at your office.",
    keywords: [
      "EU AI Act compliance training",
      "Article 4 AI literacy",
      "AI training for companies",
      "FUNDAE AI training",
      "AI compliance Barcelona",
      "AESIA preparation",
    ],
    image: `${imageBase}/ai-compliance-training.jpg`,
    imageAlt:
      "EU AI Act compliance training for companies at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "At your office"],
    duration: "PT12H",
    language: "en",
    languages: ["en", "es"],
    educationalLevel: "Professional",
    audience: "Companies and teams whose employees use AI systems at work",
    teaches: [
      "EU AI Act Article 4",
      "AI literacy",
      "Safe workplace AI use",
      "AI risk awareness",
      "AI usage policies",
      "AI systems inventory and documentation",
    ],
    price: 220,
    structuredData: false,
    alternates: [
      {
        rel: "alternate",
        hrefLang: "es",
        href: `${siteUrl}/ai-compliance-training-es/`,
      },
      {
        rel: "alternate",
        hrefLang: "x-default",
        href: `${siteUrl}/ai-compliance-training/`,
      },
    ],
  },
  "/ai-compliance-training-es/": {
    ...aiCategory,
    name: courseNames["/ai-compliance-training-es/"],
    description:
      "Prepara a tu equipo para el Artículo 4 de la Ley de IA con formación práctica y evidencias. En Barcelona, en remoto o en las oficinas de tu empresa.",
    keywords: [
      "formación Ley de IA",
      "alfabetización en IA Artículo 4",
      "formación IA empresas",
      "formación FUNDAE IA",
      "cumplimiento IA Barcelona",
      "formación AESIA",
    ],
    image: `${imageBase}/ai-compliance-training.jpg`,
    imageAlt: "Formación en cumplimiento de la Ley de IA para empresas",
    courseMode: ["Presencial", "En remoto", "En las oficinas de la empresa"],
    duration: "PT12H",
    language: "es",
    locale: "es_ES",
    languages: ["es", "en"],
    educationalLevel: "Profesional",
    audience:
      "Empresas y equipos cuyos empleados utilizan sistemas de IA en el trabajo",
    teaches: [
      "Artículo 4 de la Ley de IA",
      "Alfabetización en IA",
      "Uso seguro de IA",
      "Riesgos de la IA",
      "Políticas de uso de IA",
      "Inventario y documentación de sistemas de IA",
    ],
    price: 220,
    structuredData: false,
    alternates: [
      {
        rel: "alternate",
        hrefLang: "en",
        href: `${siteUrl}/ai-compliance-training/`,
      },
      {
        rel: "alternate",
        hrefLang: "x-default",
        href: `${siteUrl}/ai-compliance-training/`,
      },
    ],
  },
  "/bcs-young-coders-summer-camp-2026/": {
    name: courseNames["/bcs-young-coders-summer-camp-2026/"],
    description:
      "A hands-on coding summer camp in Barcelona for ages 11–18. Build websites, mobile apps, games and AI-assisted projects in English. One-week modules, €490.",
    keywords: [
      "coding summer camp Barcelona",
      "coding camp for kids",
      "teen programming camp",
      "kids web development camp",
      "AI coding for kids",
      "English summer camp Barcelona",
    ],
    image: `${imageBase}/bcs_young_coders_summer_camp_2026.jpg`,
    imageAlt: "Young Coders Summer Camp for ages 11 to 18 in Barcelona",
    courseMode: ["On campus", "In person"],
    duration: "P1W",
    courseWorkload: "20 hours per week, Monday to Friday from 09:00 to 13:00",
    language: "en",
    educationalLevel: "Beginner to intermediate",
    prerequisites:
      "No coding experience is required; students bring their own laptop.",
    audience: "Young people aged 11 to 18 interested in coding and technology",
    ageRange: "11-18",
    teaches: [
      "Web development",
      "Mobile app development",
      "Python fundamentals",
      "Creative coding",
      "Browser games",
      "AI-assisted coding",
    ],
    price: 490,
    instances: [
      {
        name: "Young Coders Summer Camp — August 10–14, 2026",
        startDate: "2026-08-10",
        endDate: "2026-08-14",
      },
      {
        name: "Young Coders Summer Camp — August 17–21, 2026",
        startDate: "2026-08-17",
        endDate: "2026-08-21",
      },
      {
        name: "Young Coders Summer Camp — August 24–28, 2026",
        startDate: "2026-08-24",
        endDate: "2026-08-28",
      },
    ],
  },
  "/design-and-prototype-in-figma/": {
    name: courseNames["/design-and-prototype-in-figma/"],
    description:
      "Learn Figma in five days through practical UX/UI exercises. Create wireframes, interactive prototypes and scalable design systems. Live in Barcelona or online.",
    keywords: [
      "Figma course Barcelona",
      "learn Figma",
      "Figma crash course",
      "UX UI design course",
      "prototyping course",
      "design systems course",
    ],
    image: `${siteUrl}/files/Banner_Figma_course.jpg`,
    imageAlt: "Design and Prototype in Figma course at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Part-time"],
    duration: "P5D",
    courseWorkload: "4 hours per day for 5 days; 20 hours total",
    language: "en",
    educationalLevel: "Beginner",
    prerequisites: "No previous Figma experience is required.",
    audience:
      "Beginners and professionals who want practical Figma and prototyping skills",
    teaches: [
      "Figma fundamentals",
      "Wireframing",
      "Interactive prototyping",
      "Components and variants",
      "Design systems",
      "Responsive interface design",
    ],
    price: 420,
    instances: [
      { startDate: "2026-08-17", endDate: "2026-08-21" },
      { startDate: "2026-09-07", endDate: "2026-09-11" },
    ],
  },
  "/branding-in-ux-ui-design-workshop/": {
    name: courseNames["/branding-in-ux-ui-design-workshop/"],
    description:
      "Learn how to translate brand strategy and identity into coherent UX/UI decisions in a four-hour, hands-on workshop for designers, product teams and founders.",
    keywords: [
      "branding UX workshop",
      "branding for UI design",
      "brand strategy course Barcelona",
      "UX UI workshop",
      "digital brand experience",
    ],
    image: `${siteUrl}/files/brandingInUx3.jpg`,
    imageAlt: "Branding in UX/UI Design workshop at Barcelona Code School",
    imageWidth: 1800,
    imageHeight: 1012,
    courseMode: ["On campus", "In person"],
    duration: "PT4H",
    courseWorkload: "One 4-hour hands-on workshop",
    language: "en",
    educationalLevel: "Professional",
    audience:
      "UX/UI designers, product designers, brand professionals, product teams and founders",
    teaches: [
      "Brand strategy in digital products",
      "Brand identity in UX/UI",
      "Interface consistency",
      "Digital brand behaviour",
    ],
    price: 120,
    instances: [{ startDate: "2026-08-19" }],
  },
  "/responsive-web-design-with-css3/": {
    name: courseNames["/responsive-web-design-with-css3/"],
    description:
      "Learn responsive web design in five intensive days. Build layouts with CSS Grid, Flexbox, media queries and cross-browser testing. Barcelona or live online.",
    keywords: [
      "responsive web design course",
      "CSS course Barcelona",
      "CSS Grid course",
      "Flexbox course",
      "front-end course",
      "learn CSS online",
    ],
    image: `${imageBase}/responsive_web_design.jpg`,
    imageAlt: "Responsive Web Design with CSS course at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P5D",
    courseWorkload: "40 hours total, Monday to Friday from 09:00 to 18:00",
    language: "en",
    educationalLevel: "Beginner",
    audience:
      "Beginners and developers who want strong responsive CSS layout skills",
    teaches: [
      "Responsive web design",
      "CSS Grid",
      "Flexbox",
      "Media queries",
      "CSS selectors",
      "The box model",
      "Cross-browser testing",
    ],
    price: 750,
    instances: [{ startDate: "2026-08-17" }, { startDate: "2026-10-19" }],
  },
  "/programming-with-javascript/": {
    name: courseNames["/programming-with-javascript/"],
    description:
      "Learn JavaScript from fundamentals to advanced programming in two intensive weeks. Build strong logic, syntax and browser skills through daily hands-on coding.",
    keywords: [
      "JavaScript course Barcelona",
      "JavaScript programming course",
      "learn JavaScript",
      "coding course for beginners",
      "JavaScript intensive course",
      "JavaScript course online",
    ],
    image: `${imageBase}/programming_with_js.jpg`,
    imageAlt: "JavaScript Programming course at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P2W",
    courseWorkload: "Monday to Friday from 09:00 to 18:00 for 2 weeks",
    language: "en",
    educationalLevel: "Beginner to advanced",
    audience:
      "Beginners who want a practical foundation in JavaScript programming",
    teaches: [
      "Programming logic",
      "JavaScript syntax",
      "Variables and data types",
      "Functions",
      "Arrays and objects",
      "DOM programming",
      "Asynchronous JavaScript",
    ],
    price: 1200,
    instances: [{ startDate: "2026-08-24" }, { startDate: "2026-10-26" }],
  },
  "/reactjs-crash-course/": {
    name: courseNames["/reactjs-crash-course/"],
    description:
      "Learn React in one intensive week. Build and deploy apps using components, hooks, routing, state management and asynchronous requests. Barcelona or live online.",
    keywords: [
      "React course Barcelona",
      "React.js crash course",
      "learn React",
      "front-end development course",
      "React hooks course",
      "React course online",
    ],
    image: `${imageBase}/react_crash_course.jpg`,
    imageAlt: "React.js Crash Course at Barcelona Code School",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P5D",
    courseWorkload: "40 hours total, Monday to Friday from 09:00 to 18:00",
    language: "en",
    educationalLevel: "Intermediate",
    prerequisites: "Basic JavaScript, HTML and CSS knowledge is required.",
    audience:
      "JavaScript learners who want practical front-end development skills with React",
    teaches: [
      "React components",
      "React hooks",
      "State management",
      "React Router",
      "Asynchronous requests",
      "React application deployment",
    ],
    price: 850,
    instances: [{ startDate: "2026-09-07" }, { startDate: "2026-11-09" }],
  },
  "/backend-development-with-node-express-mongodb/": {
    name: courseNames["/backend-development-with-node-express-mongodb/"],
    description:
      "Learn backend development in one intensive week. Build servers and APIs with Node.js and Express, connect MongoDB databases, and complete practical projects.",
    keywords: [
      "Node.js course Barcelona",
      "backend development course",
      "Express course",
      "MongoDB course",
      "REST API course",
      "Node.js course online",
    ],
    image: `${imageBase}/backend_course.jpg`,
    imageAlt: "Backend Development with Node.js, Express and MongoDB course",
    courseMode: ["On campus", "Remote live", "Full-time"],
    duration: "P5D",
    courseWorkload: "40 hours total, Monday to Friday from 09:00 to 18:00",
    language: "en",
    educationalLevel: "Intermediate",
    prerequisites: "Basic JavaScript knowledge is required.",
    audience:
      "JavaScript learners who want to build server-side applications and APIs",
    teaches: [
      "Node.js",
      "Express",
      "MongoDB",
      "REST APIs",
      "Server-side JavaScript",
      "Database integration",
    ],
    price: 850,
    instances: [{ startDate: "2026-09-14" }, { startDate: "2026-11-16" }],
  },
  "/corporate-training/": {
    name: courseNames["/corporate-training/"],
    description:
      "Custom corporate AI training for teams in AI literacy, EU AI Act compliance and automation. Delivered in Barcelona, at your office or live online.",
    socialDescription:
      "Train your team in practical AI, EU AI Act compliance, automation and technical skills with a custom programme, onsite in Barcelona or live online.",
    keywords: [
      "corporate AI training",
      "AI training for companies",
      "corporate AI training Barcelona",
      "EU AI Act compliance training",
      "AI automation consulting",
      "AI integration services",
      "corporate tech training Barcelona",
      "custom team training",
      "onsite AI workshops",
      "enterprise AI literacy",
      "n8n training for companies",
    ],
    image: corporateTrainingImage,
    imageAlt:
      "A team completing instructor-led technology training at Barcelona Code School",
    imageWidth: 1800,
    imageHeight: 1200,
    imageType: "image/jpeg",
    dateModified: "2026-08-31",
    schemaType: "Service",
    serviceType: [
      "Corporate AI training",
      "EU AI Act compliance training",
      "AI automation integration",
      "Custom technology training",
    ],
    language: "en",
    languages: ["en", "es"],
    audience:
      "Companies, leadership teams, technical teams, operations teams, product teams and regulated organisations",
    areaServed: [
      "Barcelona",
      "Catalonia",
      "Spain",
      "European Union",
      "Remote worldwide",
    ],
    breadcrumbCategory: "For companies",
    categoryUrl: `${siteUrl}/corporate-training/`,
    serviceCatalogName: "Corporate AI and technology services",
    serviceCatalog: [
      {
        name: "Custom AI Training for Teams",
        description:
          "Role-based, instructor-led AI training covering practical workplace use, prompting, AI agents, RAG, responsible use and technical implementation.",
      },
      {
        name: "EU AI Act Compliance Training",
        description:
          "Practical AI literacy and compliance training with role-based instruction and documentation for organisations whose teams use AI systems.",
      },
      {
        name: "AI Automation and Integration",
        description:
          "Workflow discovery, AI-agent prototyping and integration using tools such as n8n, APIs, RAG knowledge bases and human approval controls.",
      },
      {
        name: "Software Development Training",
        description:
          "Custom team training in JavaScript, TypeScript, React, React Native, Node.js, APIs, databases and AI-enabled development.",
      },
      {
        name: "UX/UI and Product Design Training",
        description:
          "Practical workshops in user research, product discovery, prototyping, usability testing, Figma, interface design and design systems.",
      },
    ],
    faqs: [
      {
        question:
          "What corporate AI training does Barcelona Code School offer?",
        answer:
          "Barcelona Code School provides custom AI literacy, practical workplace AI, AI-agent engineering, workflow automation, RAG, responsible AI and EU AI Act compliance training for business and technical teams.",
      },
      {
        question:
          "Can the training be customised for our company and industry?",
        answer:
          "Yes. The school starts with your roles, tools, workflows and objectives, then adapts the curriculum, exercises, pace and examples to your organisation.",
      },
      {
        question: "Where is corporate training delivered?",
        answer:
          "Training can be delivered at your office, live online or at Barcelona Code School's campus in Barcelona, in English or Spanish.",
      },
      {
        question:
          "Do you provide EU AI Act compliance and AI literacy training?",
        answer:
          "Yes. Role-based AI literacy and EU AI Act compliance training is available for companies, including practical guidance and training documentation.",
      },
      {
        question: "Can you help our team automate and integrate AI workflows?",
        answer:
          "Yes. Engagements can include workflow discovery, automation design, proof-of-concept AI agents, n8n and API integrations, RAG knowledge systems, human approval controls, testing and team handover.",
      },
      {
        question: "How much does custom corporate training cost?",
        answer:
          "Pricing depends on the objectives, curriculum, number of participants, duration, delivery location and required implementation support. Barcelona Code School provides a tailored proposal after an initial consultation.",
      },
    ],
  },
};
